<template>
	<div
		class="form-input time-input"
		:class="{
			'error': !isValid,
			'focus': isFocused,
			'disabled': disabled
		}"
	>
		<slot name="left" />
		<input
			v-model="internalValue"
			type="text"
			:style="inputStyle"
			:disabled="disabled"
			:readonly="readonly"
			@input="handleChange"
			@focusin="handleFocusIn"
			@focusout="handleFocusOut"
		>
		<slot name="right" />
	</div>
</template>

<script>
const secondsToTime = (val) => {
	const isNegative = val < 0;

	// Convert all values to positive numbers
	val = Math.abs(val);

	const minutes = Math.floor(val / 60);
	const seconds = val - minutes * 60;
	return `${isNegative ? '-' : ''}${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

const toSeconds = (str) => {
	const split = str.split(':');
	return (parseInt(split[0]) * 60 + parseInt(split[1] || 0)) || null;
};

const timeValid = (time) => {
	const split = time.split(':');
	if (split.length === 1) return true;
	const seconds = split[1];
	if (seconds && seconds.length > 2) return false;
	return true;
};

export default {
	name:  'TimeInput',
	props: {
		value: {
			type:    Number,
			default: 0,
		},
		align: {
			type:    String,
			default: 'left',
		},
		isValid: {
			type:    Boolean,
			default: false,
		},
		disabled: {
			type:    Boolean,
			default: false,
		},
		readonly: {
			type:    Boolean,
			default: false,
		},
	},
	data() {
		return {
			internalValue: '00:00',
			isFocused:     false,
		};
	},
	computed: {
		inputStyle() {
			return {
				textAlign: this.align || 'left',
			};
		},
	},
	watch: {
		internalValue(val, oldVal) {
			if (val && !timeValid(val)) this.internalValue = oldVal;
		},
		value(val) {
			// check that prevents handleChange from changing internalValue while we are writing in the input
			if (val && val !== toSeconds(this.internalValue)) this.internalValue = secondsToTime(Math.round(val));
		},
	},
	created() {
		this.internalValue = secondsToTime(Math.round(this.value));
	},
	methods: {
		handleChange() {
			if (!this.internalValue || timeValid(this.internalValue)) {
				const numberValue = toSeconds(this.internalValue);
				this.$emit('input', numberValue);
			}
		},
		handleFocusIn() {
			this.isFocused = true;
		},
		handleFocusOut() {
			this.isFocused = false;
			if (this.value) this.internalValue = secondsToTime(Math.round(this.value));
		},
	},
};
</script>

<style lang="scss" scoped>

.time-input {
	display: flex !important;

	input {
		overflow: auto;
		flex: 1 1 auto;
		width: 100%;
	}
}

</style>
